<template>
  <div class="search-form p-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <div class="row">
        <div class="col-sm-4">
            <span class="span-title">
              {{ $t('orders.status') }}
            </span>
            <div class="mb-3">
                <select
                    id="status"
                    v-model="status"
                    class="form-select form-select-sm"
                >
                    <option :value="-1">
                        {{ $t('orders.select_status') }}
                    </option>
                    <option :value="0">
                        {{ $t('inspection.options.open') }}
                    </option>
                    <option :value="2">
                        {{ $t('inspection.options.okay') }}
                    </option>
                    <option :value="3">
                        {{ $t('inspection.options.defects') }}
                    </option>
                    <option :value="4">
                        {{ $t('inspection.options.ban') }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-sm-4">
            <span class="span-title">
              {{ $t('trip_list.vehicle') }}
            </span>
            <div class="mb-3">
                <select
                    id="vehicle"
                    v-model="vehicle"
                    class="form-select form-select-sm"
                >
                    <option :value="-1">
                        {{ $t('orders.select_status') }}
                    </option>
                    <option
                        v-for="v in vehicles"
                        :key="v.id"
                        :value="v.id"
                    >
                        {{ v.make }} {{ v.vehicle_model }} {{ v.license_plate }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-sm-4">
            <span class="span-title">
              {{ $t('defects.reporter') }}
            </span>
            <div class="mb-3">
                <select
                    id="reporter"
                    v-model="reporter"
                    class="form-select form-select-sm"
                >
                    <option :value="-1">
                        {{ $t('orders.select_status') }}
                    </option>
                    <option
                        v-for="r in reporters"
                        :key="r.id"
                        :value="r.id"
                    >
                        {{ r.last_name }}, {{ r.first_name }}
                    </option>
                </select>
            </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
            <span class="span-title">
              {{ $t('orders.create_time') }} - {{ $t('trip_list.road_sec_from') }}
            </span>
            <div class="mb-3">
                <input
                    id="start"
                    v-model="fromDate"
                    type="date"
                    class="form-control form-control-sm"
                />
            </div>
        </div>
        <div class="col-sm-4">
            <span class="span-title">
              {{ $t('orders.create_time') }} - {{ $t('trip_list.road_sec_to') }}
            </span>
            <div class="mb-3">
                <input
                    id="end"
                    v-model="toDate"
                    type="date"
                    class="form-control form-control-sm"
                />
            </div>
        </div>
      </div>
      <div class="col-sm-12 button-container">
        <button type="reset" class="btn btn-danger form-button">
          {{ $t('ins_report.clear') }}
        </button>
        <button type="submit" class="btn btn-primary form-button">
              {{ $t('ins_report.search') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'

export default {
    name: 'VehicleDefectSearch',
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            status: 0,
            vehicle: -1,
            vehicles: [],
            fromDate: null,
            toDate: null,
            reporter: -1,
            reporters: []
        }
    },
    mounted: function () {
        this.fetchVehicles()
        this.fetchReporters()
    },
    methods: {
        fetchVehicles: function () {
            this.loading = true
            this.restFetch(this.vehicleDefectVehiclesUrl, this.handleVehicles)
        },

        handleVehicles: function (response) {
            this.loading = false
            this.vehicles = response.data
        },

        fetchReporters: function () {
            this.loading = true
            this.restFetch(this.vehicleDefectReporterUrl, this.handleReporters)
        },

        handleReporters: function (response) {
            this.loading = false
            this.reporters = response.data
        },

        onSubmit: function () {
            var params = {}
            if (this.status >= 0) {
                params.status = this.status
            }
            if (this.vehicle > 0) {
                params.vehicle = this.vehicle
            }
            if (this.reporter > 0) {
                params.reporter = this.reporter
            }
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.dateFrom = this.localTimeToUtcTime(this.fromDate).getTime()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.dateTo = this.getEndOfTheDay(this.toDate).getTime()

            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.status = 0
            this.vehicle = -1
            this.reporter = -1
            this.fromDate = null
            this.toDate = null
        }
    }
}
</script>

<style scoped>

</style>
